import { render, staticRenderFns } from "./ListPatroliJalanTolPage.vue?vue&type=template&id=457ad2b4&scoped=true"
import script from "./ListPatroliJalanTolPage.vue?vue&type=script&lang=js"
export * from "./ListPatroliJalanTolPage.vue?vue&type=script&lang=js"
import style0 from "./ListPatroliJalanTolPage.vue?vue&type=style&index=0&id=457ad2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ad2b4",
  null
  
)

export default component.exports